const Redirect = class {
  constructor () {
    this.init()
  }
  init () {
    this.initRedirects()
  }

  getStoreRedirectData () {
    return {
      "CA": "https://ca.plaud.ai",
      "AU": "https://au.plaud.ai",
      "FR": "https://fr.plaud.ai",
      "HK": "https://hk.plaud.ai",
      "TW": "https://tw.plaud.ai",
      "GB": "https://uk.plaud.ai",
      "JP": "https://jp.plaud.ai",
      "AX": "https://eu.plaud.ai",
      "AL": "https://eu.plaud.ai",
      "AD": "https://eu.plaud.ai",
      "AT": "https://eu.plaud.ai",
      "BY": "https://eu.plaud.ai",
      "BE": "https://eu.plaud.ai",
      "BA": "https://eu.plaud.ai",
      "BG": "https://eu.plaud.ai",
      "HR": "https://eu.plaud.ai",
      "CZ": "https://eu.plaud.ai",
      "DK": "https://eu.plaud.ai",
      "EE": "https://eu.plaud.ai",
      "FO": "https://eu.plaud.ai",
      "FI": "https://eu.plaud.ai",
      "DE": "https://eu.plaud.ai",
      "GI": "https://eu.plaud.ai",
      "GR": "https://eu.plaud.ai",
      "VA": "https://eu.plaud.ai",
      "HU": "https://eu.plaud.ai",
      "IS": "https://eu.plaud.ai",
      "IE": "https://eu.plaud.ai",
      "IM": "https://eu.plaud.ai",
      "IT": "https://eu.plaud.ai",
      "JE": "https://eu.plaud.ai",
      "LV": "https://eu.plaud.ai",
      "LI": "https://eu.plaud.ai",
      "LT": "https://eu.plaud.ai",
      "LU": "https://eu.plaud.ai",
      "MT": "https://eu.plaud.ai",
      "MD": "https://eu.plaud.ai",
      "MC": "https://eu.plaud.ai",
      "ME": "https://eu.plaud.ai",
      "NL": "https://eu.plaud.ai",
      "NO": "https://eu.plaud.ai",
      "PL": "https://eu.plaud.ai",
      "PT": "https://eu.plaud.ai",
      "RO": "https://eu.plaud.ai",
      "RU": "https://eu.plaud.ai",
      "SM": "https://eu.plaud.ai",
      "RS": "https://eu.plaud.ai",
      "SK": "https://eu.plaud.ai",
      "SI": "https://eu.plaud.ai",
      "ES": "https://eu.plaud.ai",
      "SJ": "https://eu.plaud.ai",
      "SE": "https://eu.plaud.ai",
      "CH": "https://eu.plaud.ai",
      "UA": "https://eu.plaud.ai",
      "default": "https://www.plaud.ai"
    }
  }

  initRedirects () {
    if (this.shouldNotRedirect()) return;
    const stores = this.getStoreRedirectData()
    if (!stores) return
    fetch('/browsing_context_suggestions.json')
      .then(response => response.json())
      .then(data => {
        const countryCode = data?.detected_values?.country?.handle?.toUpperCase()
        if (!countryCode) return

        let storeDomain = stores[countryCode] || stores.default
        if (!storeDomain) return
        let storeOrigin = new URL(storeDomain).origin
      
        const currentDomain = this.getCurrentDomain()
        if (currentDomain !== storeOrigin) {
          const alternateTags = this.getLanguageIdentifiers()

          const redirectPagePath = this.getPathAfterPrefix(alternateTags)
          const redirectUrl = `${storeDomain}${redirectPagePath}`
          window.location.href = redirectUrl
        }
      })
  }

  shouldNotRedirect() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isBot = /bot|crawl|slurp|spider/i.test(userAgent);
    const isBlogsPath = window.location.pathname.includes('/blogs/');

    return isBot || isBlogsPath;
  }

  getLanguageIdentifiers () {
    const alternateTags = document.querySelectorAll('link[rel="alternate"]')
    const languageIdentifiers = []
  
    alternateTags.forEach(tag => {
      let href = tag.href
      if (!href.endsWith('/')) {
        href += '/'
      }
      const url = new URL(href)
      const pathSegments = url.pathname.split('/')
      const firstSegment = pathSegments[1]
      const regex = /^\/[^/]+\/$/
      const pathRegex = /\/(pages|products|collections|account|cart|search|blogs|404|policies|apps)\/(.+)/
      if (regex.test(firstSegment) && !pathRegex.test(firstSegment)) {
        languageIdentifiers.push(firstSegment)
      }
    })

    return languageIdentifiers
  }

  getCurrentDomain () {
    return window.location.origin
  }
  getPathAfterPrefix (prefixes) {
    const currentPath = window.location.pathname.substring(1)
    for (const prefix of prefixes) {
      if (currentPath.startsWith(prefix + '/')) {
        return '/' + currentPath.substring(prefix.length + 1)
      }
    }

    return '/' + currentPath
  }
}

const PageRedirect = new Redirect()
